import moment from 'moment'

const combineDateTime = (date, time) => {
  const timeMoment = moment(time)
  return moment(date)
    .hours(timeMoment.hours())
    .minutes(timeMoment.minutes())
    .seconds(0)
    .milliseconds(0)
    .toDate()
}

export default combineDateTime
